// @ts-nocheck

import React, { useState } from "react";
import { notification } from "antd";
import "../Login.css";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import CustomForm from "../../../shared/components/CustomForm";
import back from "../../../theme/images/back.jpeg";
import { resetPassword } from "../../../engine/api/apiRequest";
import { throttle } from "lodash";
import { HiOutlineMail } from "react-icons/hi";
import { getLogoByCustomer } from "../../../engine/customerConfig";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../../shared/components/LanguageSelector";

export const PasswordLost = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const throttledSubmit = throttle(async data => {
    setLoading(true);

    let send = await resetPassword(data);
    // Mock an API call

    notification.success({
      message: t("passwordLost.requestPassword"),
      description: t("passwordLost.emailSentDescription"),
    });
    await new Promise(resolve => setTimeout(resolve, 1000));

    setLoading(false);
  }, 2000); // Limit to one submission every 2 seconds

  const inputs = [
    {
      parentLabel: t("passwordLost.enterEmail"),
      children: [
        {
          label: t("passwordLost.emailLabel"),
          placeholder: t("passwordLost.emailLabel"),
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          capitalize: false,
          type: "input",
          required: true,
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: t("passwordLost.sendRequest"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "left",
        },
      ],
    },
  ];

  return (
    <div className={"login-back"} style={{ backgroundImage: `url(${back})` }}>
      <Helmet>
        <title>{t("passwordLost.title")}</title>
      </Helmet>
      <div className={"login-container"}>
        <div className={"login-box"}>
          <Link className="login-form-forgot" to="/auth/login">
            <LanguageSelector lang={"fr"} />
            <img
              src={getLogoByCustomer()}
              className={"login-logo"}
              alt={"logo-oseo"}
            />
          </Link>
          <CustomForm
            dataSource={inputs}
            labelCol={24}
            wrapperCol={24}
            loading={loading}
            handleSubmit={throttledSubmit}
          />
        </div>
      </div>
    </div>
  );
};
